import { baseURL } from "./axios";

export async function fetchCsrfToken() {
  const response = await fetch(`${baseURL}/csrf/`, {
    method: 'GET',
    credentials: 'include', 
  });
  const data = await response.json();
  return data.csrfToken;
}